module.exports = __webpack_public_path__ + "images/rolodex_tab_selected.png";